import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { CSSTransitionGroup } from 'react-transition-group';

import Loader from 'components/loader';

export default class Button extends Component {

  /* Render */

  render() {
    const { className, disabled, onClick, type } = this.props;

    return (
      <button
        className={className}
        disabled={disabled}
        onClick={onClick}
        type={type}
      >
        <CSSTransitionGroup
          transitionName="button"
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {this.renderChildren()}
          {this.renderLoader()}
        </CSSTransitionGroup>
      </button>
    );
  }

  renderLoader() {
    const { loading } = this.props;
    if (loading) {
      return (
        <div className="button__loader">
          <Loader size="sm" color="#fff" visible={loading} />
        </div>
      );
    }

    return null;
  }

  renderChildren() {
    const { children, text, loading } = this.props;
    let content = null;

    if (loading) return null;

    if (children) {
      content = children;
    } else {
      content = <FormattedMessage id={text} />;
    }

    return (
      <div className="button__content">
        {content}
      </div>
    );
  }
}

Button.defaultProps = {
  type: 'button',
};

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  onClick: PropTypes.func,
  text: PropTypes.string,
  type: PropTypes.string,
};



// WEBPACK FOOTER //
// ./js/components/button/index.jsx